import config from "../assets/config"; // Import the config file
import useResponsive from "./useResponsive";
import PreviewCard from "./PreviewCard";
import useServiceBadge from "./useServiceBadge";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
function CardGallery({
	style,
    cards
}) {
    const navigate = useNavigate();
    const { t } = useTranslation();
	const isMobile = useResponsive();
	const getServiceBadge = useServiceBadge();


	const galleryStyle = {
		display: "flex",
		flexWrap: "wrap",
		justifyContent: "center",
		width: "100%",
		overflow: "auto",
		background: "transparent",
		...style,
	};
    const isExternalUrl = (url) => {
        return url.startsWith('http://') || url.startsWith('https://') || url.startsWith('www.');
    };
    const handleNavigation = (url) => {
        if (isExternalUrl(url)) {
            // If the URL is external, use window.location to navigate
            window.location.href = url;
        } else {
            // If the URL is internal, use the navigate function from React Router
            navigate(url);
        }
    };

	return (
		<div style={galleryStyle}>
			{cards.map((card) => (
					<PreviewCard
						key={card.id}
						image={!card.image ? undefined : String(card.image).startsWith("http") ? card.image : `${process.env.PUBLIC_URL}/content/projects/${card.nameid}/${card.image}`}
						title={card.title}
						description={card.description}
						config={config}
						style={{
							backgroundColor: "rgba(255,255,255,0.95)",
							...(isMobile
								? {
										minWidth: "80vw",
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
								  }
								: {}),
						}}
						buttonText={t(card.buttonText)}
						onButtonClick={() => card.url ? handleNavigation(card.url) : handleNavigation(`/projects/${card.nameid}`)}
						direction={"v"}
						imageStyle={{
							aspectRatio: "4/3",
							maxWidth: isMobile ? "60vh" : "600px",
							...(isMobile ? { width: "100%", margin: "auto" } : {}),
						}}
						itemsStyle={{
							margin: "auto",
							width: "100%",
							height: "100%",
							display: "flex",
							padding: "10px",
						}}
						notificationImage={getServiceBadge(card)}
					/>
			))}
		</div>
	);
}

export default CardGallery;
